module.exports = __webpack_public_path__ + "img/telephone.9c772135.jpg";